import styled from "styled-components";

type ContainerProps = {
  variant?: "default" | "danger";
};

export const Container = styled.button<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  color: ${({ variant }) => (variant === "danger" ? "#ef4444" : "var(--fixit)")};
  font-size: 14px;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid ${({ variant }) => (variant === "danger" ? "#ef4444" : "var(--fixit)")};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
  height: 40px;

  &:hover {
    background: ${({ variant }) => (variant === "danger" ? "#fef2f2" : "var(--fixit-hover-bg)")};
    border-color: ${({ variant }) => (variant === "danger" ? "#dc2626" : "var(--fixit-hover)")};
    color: ${({ variant }) => (variant === "danger" ? "#dc2626" : "var(--fixit)")};

    svg {
      color: ${({ variant }) => (variant === "danger" ? "#dc2626" : "var(--fixit-hover)")};
    }
  }

  &:disabled {
    border-color: var(--light-gray);
    color: var(--light-gray);
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }

  svg {
    color: ${({ variant }) => (variant === "danger" ? "#ef4444" : "var(--fixit)")};
  }

  .loading {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top: 2px solid ${({ variant }) => (variant === "danger" ? "#ef4444" : "var(--fixit)")};
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
